module.exports = __webpack_public_path__ + "static/media/04.7689a3df.gif";